import { Option } from '../../../../config/types/component'
import useGet from '../../../../hooks/useGet'
import {
    formConsumptionVoucher,
    productsControl,
    reqProducts,
    reqStowage,
    reqSubStowage,
    storagePage
} from '../../storage'
import { GetStowage } from '../../types'

export default function useStowage() {
    const { props } = formConsumptionVoucher.useSelect('stowage')
    const { data, props: propsSearch } = useGet<GetStowage[]>(
        reqStowage.observer(
            '/v5.6/apis/stowages?limit=10&is_enabled=true&require_all_substowages=false',
            true
        ),
        []
    )

    function handleChange(option: Option) {
        props.onChange(option)

        if (option.value === '0') {
            formConsumptionVoucher.setProps(
                'sub_stowage',
                {
                    disabled: true
                },
                false
            )
            formConsumptionVoucher.setProps(
                'products',
                { disabled: true },
                false
            )
        } else {
            const { type_stowage_id, minimal_stowage_principal }: any =
                data.result.find(
                    stowage => stowage.id === parseInt(option.value)
                )

            storagePage.current_type_stowage_id_origin = type_stowage_id

            const isPGR =
                type_stowage_id === 2 || // Pedidos (P)
                type_stowage_id === 6 || // Garantía proveedor (G)
                type_stowage_id === 11 // Remisionada (R)

            if (isPGR) {
                reqSubStowage.setParam('stowage_id', option.value)
                reqSubStowage.load()
            } else {
                reqProducts.setQuery(
                    'origin_minimal_stowage_id',
                    minimal_stowage_principal.id
                )
                storagePage.current_stowage_origin_id =
                    minimal_stowage_principal.id
                reqProducts.load()
            }

            formConsumptionVoucher.setProps(
                'sub_stowage',
                { disabled: !isPGR },
                false
            )
            formConsumptionVoucher.setProps(
                'products',
                { disabled: isPGR },
                false
            )
        }

        formConsumptionVoucher.setValue('sub_stowage', null)
        formConsumptionVoucher.setValue('products', [])
        reqProducts.deleteQuery('not_logical_product_ids')
        reqProducts.load()
        productsControl.setList([])
        productsControl.renderMain()
    }

    return { props, stowages: data.result, handleChange, propsSearch }
}
